var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectStep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#1890FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 14.2647L13 10.8047",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 18.6679V13.3346C21.9998 13.1008 21.938 12.8711 21.821 12.6687C21.704 12.4662 21.5358 12.2981 21.3333 12.1812L16.6667 9.51457C16.464 9.39755 16.234 9.33594 16 9.33594C15.766 9.33594 15.536 9.39755 15.3333 9.51457L10.6667 12.1812C10.4642 12.2981 10.296 12.4662 10.179 12.6687C10.062 12.8711 10.0002 13.1008 10 13.3346V18.6679C10.0002 18.9017 10.062 19.1314 10.179 19.3338C10.296 19.5362 10.4642 19.7043 10.6667 19.8212L15.3333 22.4879C15.536 22.6049 15.766 22.6665 16 22.6665C16.234 22.6665 16.464 22.6049 16.6667 22.4879L21.3333 19.8212C21.5358 19.7043 21.704 19.5362 21.821 19.3338C21.938 19.1314 21.9998 18.9017 22 18.6679Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1797 12.6406L15.9997 16.0073L21.8197 12.6406",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 22.72V16",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectStep);
export default __webpack_public_path__ + "static/media/SelectStep.ec8c5060.svg";
export { ForwardRef as ReactComponent };